import PasswordValidator from 'password-validator';
import type { RuleNames } from 'react-password-checklist';

export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_LENGTH = 29;

export const PASSWORD_CHECKLIST_RULES: RuleNames[] = [
    'minLength',
    'maxLength',
    'capital',
    'number',
    'match',
];

const passwordSchema = new PasswordValidator()
    .is()
    .min(PASSWORD_MIN_LENGTH)
    .is()
    .max(PASSWORD_MAX_LENGTH)
    .has()
    .uppercase(1)
    .has()
    .digits(1);

export const isPasswordValid = (value: string): boolean =>
    passwordSchema.validate(value) as boolean;
